import { useState } from 'react';
import type { Customer } from '../types';
import SuspendAccount from './ActionForms/SuspendAccount';
import CloseAccount from './ActionForms/CloseAccount';
import AddNotes from './ActionForms/AddNotes';

interface CustomerActionsProps {
  customer: Customer;
  onActionComplete: () => void;
}

type ActionModal = 'suspend' | 'close' | 'notes' | null;

export default function CustomerActions({ customer, onActionComplete }: CustomerActionsProps) {
  const [activeModal, setActiveModal] = useState<ActionModal>(null);

  const handleActionComplete = () => {
    setActiveModal(null);
    onActionComplete();
  };

  return (
    <>
      <div className="card">
        <h2 className="text-lg font-medium text-gray-900 mb-4">Actions</h2>
        <div className="space-y-3">
          <button
            onClick={() => setActiveModal('notes')}
            className="w-full btn-primary"
          >
            Add Note
          </button>

          {!customer.is_closed && (
            <>
              <button
                onClick={() => setActiveModal('suspend')}
                className="w-full btn-warning"
              >
                Suspend Account
              </button>

              <button
                onClick={() => setActiveModal('close')}
                className="w-full btn-danger"
              >
                Close Account
              </button>
            </>
          )}
        </div>

        {customer.is_closed && (
          <p className="mt-4 text-sm text-gray-500 text-center">
            This account is closed. Some actions are unavailable.
          </p>
        )}
      </div>

      {/* Modals */}
      {activeModal === 'suspend' && (
        <SuspendAccount
          customer={customer}
          onClose={() => setActiveModal(null)}
          onSuccess={handleActionComplete}
        />
      )}

      {activeModal === 'close' && (
        <CloseAccount
          customer={customer}
          onClose={() => setActiveModal(null)}
          onSuccess={handleActionComplete}
        />
      )}

      {activeModal === 'notes' && (
        <AddNotes
          customer={customer}
          onClose={() => setActiveModal(null)}
          onSuccess={handleActionComplete}
        />
      )}
    </>
  );
}
